(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kit-configurator-dt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dt-kit-selector')) {
    customElements.define('dt-kit-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.order = ['ways', 'kitType', 'housingStyle', 'wireRange', 'plating'];
        this.state = Object.fromEntries(this.order.map((key) => [key, null]));
        this.steps = Object.fromEntries(this.order.map((key) => [key, this.querySelector(`[data-step="${key}"]`)]));
        this.review = this.querySelector('[data-review]');
        this.summary = this.querySelector('[data-summary]');
        this.status = this.querySelector('[data-status]');
        this.resultHeading = this.querySelector('[data-result-heading]');
        this.notice = this.querySelector('[data-notice]');
        this.productLink = this.querySelector('[data-product-link]');
        this.products = {
          '2|receptacle|standard|20-16|gold': 'dt-2-way-pin-receptacle',
          '2|flanged_receptacle|standard|20-16|gold': '2-way-deutsch-dt04-2p-l012-flanged-receptacle-connector-kit-gold-pins-20-16-awg',
          '2|plug|standard|20-16|gold': '2-way-deutsch-dt06-2-splug-connector-kit-gold-sockets-20-16-awg',
          '2|plug|e008|20-16|gold': 'dt-2-way-socket-plug',
          '2|mated|standard|20-16|gold': '2-way-mated-deutsch-dt-connector-kit-dt04-2p-and-dt06-2s-20-16-awg',
          '2|mated|standard|20-16|nickel': '2-way-mated-deutsch-dt-connector-kit-dt04-2p-and-dt06-2s-nickel-20-16-awg',
          '2|mated|e008|20-16|gold': 'mated-dt-connector-kits-2-way',
          '2|flanged_mated|standard|20-16|gold': '2-way-mated-deutsch-dt-connector-kit-dt04-2p-l012-and-dt06-2s-gold-20-16-awg',
          '3|receptacle|standard|20-16|gold': 'dt-3-way-pin-receptacle',
          '3|flanged_receptacle|standard|20-16|gold': '3-way-deutsch-dt04-3p-l012-flanged-receptacle-connector-kit-gold-pins-20-16-awg',
          '3|plug|standard|20-16|gold': '3-way-deutsch-dt06-3s-plug-connector-kit-gold-sockets-20-16-awg',
          '3|plug|e008|20-16|gold': 'dt-3-way-socket-plug',
          '3|mated|standard|20-16|gold': '3-way-mated-deutsch-dt-connector-kit-dt04-3p-and-dt06-3s-gold-20-16-awg',
          '3|mated|standard|20-16|nickel': '3-way-mated-deutsch-dt-connector-kit-dt04-3p-and-dt06-3s-nickel-20-16-awg',
          '3|mated|e008|20-16|gold': 'mated-dt-connector-kits-3-way',
          '3|flanged_mated|standard|20-16|gold': '3-way-mated-deutsch-dt-connector-kit-dt04-3p-l012-and-dt06-3s-gold-20-16-awg',
          '4|receptacle|standard|20-16|gold': 'dt-4-way-pin-receptacle',
          '4|flanged_receptacle|standard|20-16|gold': '4-way-deutsch-dt04-4p-flanged-l012-receptacle-connector-kit-gold-pins-20-16-awg',
          '4|plug|standard|20-16|gold': '4-way-deutsch-dt06-4s-plug-connector-kit-gold-sockets-20-16-awg',
          '4|plug|e008|20-16|gold': 'dt-4-way-socket-plug',
          '4|mated|standard|20-16|gold': '4-way-mated-deutsch-dt-connector-kit-dt04-4p-and-dt06-4s-gold-20-16-awg',
          '4|mated|standard|20-16|nickel': '4-way-mated-deutsch-dt-connector-kit-dt04-4p-and-dt06-4s-nickel-20-16-awg',
          '4|mated|e008|20-16|gold': 'mated-dt-connector-kits-4-way',
          '4|flanged_mated|standard|20-16|gold': '4-way-mated-deutsch-dt-connector-kit-dt04-4p-l012-and-dt06-4s-gold-20-16-awg',
          '6|receptacle|standard|20-16|gold': 'dt-6-way-pin-receptacle',
          '6|flanged_receptacle|standard|20-16|gold': '6-way-deutsch-dt04-6p-l012-flanged-receptacle-connector-kit-gold-pins-20-16-awg',
          '6|plug|standard|20-16|gold': 'dt-6-way-socket-plug',
          '6|plug|e008|20-16|gold': '6-way-deutsch-dt06-6s-e008-plug-connector-kit-gold-sockets-20-16-awg',
          '6|mated|standard|20-16|gold': '6-way-mated-deutsch-dt-connector-kit-dt04-6p-and-dt06-6s-gold-20-16-awg',
          '6|mated|standard|20-16|nickel': '6-way-mated-deutsch-dt-connector-kit-dt04-6p-and-dt06-6s-nickel-20-16-awg',
          '6|mated|e008|20-16|gold': 'mated-dt-connector-kits-6-way',
          '6|flanged_mated|standard|20-16|gold': '6-way-mated-deutsch-dt-connector-kit-dt04-6p-l012-and-dt06-6s-gold-20-16-awg',
          '8|receptacle|standard|20-16|gold': '8-way-deutsch-dt04-8pa-receptacle-connector-kit-pins-20-16-awg',
          '8|flanged_receptacle|standard|20-16|gold': '8-way-deutsch-dt04-08pa-l012-flanged-receptacle-connector-kit-gold-pins-20-16-awg',
          '8|plug|standard|20-16|gold': '8-way-deutsch-dt06-08sa-plug-connector-kit-sockets-20-16-awg',
          '8|plug|e008|20-16|gold': '8-way-deutsch-dt06-08sa-e008-plug-connector-kit-sockets-20-16-awg',
          '8|mated|standard|20-16|gold': 'mated-deutsch-dt-8-way-connector-kit-20-16-awg',
          '8|mated|standard|20-16|nickel': '8-way-mated-deutsch-dt-key-a-connector-kit-dt04-08pa-and-dt06-08sa-nickel-20-16-awg',
          '8|mated|e008|20-16|gold': '8-way-mated-deutsch-dt-key-a-connector-kit-dt04-08pa-and-dt06-08sa-e008-20-16-awg',
          '8|flanged_mated|standard|20-16|gold': '8-way-mated-deutsch-dt-key-a-connector-kit-dt04-08pa-l012-and-dt06-08sa-gold-20-16-awg',
          '12|receptacle|standard|20-16|gold': '12-way-deutsch-dt04-12pa-receptacle-connector-kit-pins-20-16-awg',
          '12|flanged_receptacle|standard|20-16|gold': '12-way-deutsch-dt04-12pa-l012-flanged-receptacle-connector-kit-gold-pins-20-16-awg',
          '12|plug|standard|20-16|gold': '12-way-deutsch-dt06-12sa-plug-connector-kit-sockets-20-16-awg',
          '12|plug|e008|20-16|gold': '12-way-deutsch-dt06-12sa-e008-plug-connector-kit-sockets-20-16-awg',
          '12|mated|standard|20-16|gold': 'mated-deutsch-dt-12-way-key-a-connector-kit-20-16-awg',
          '12|mated|standard|20-16|nickel': '12-way-mated-deutsch-dt-key-a-connector-kit-dt04-12pa-and-dt06-12sa-nickel-20-16-awg',
          '12|mated|e008|20-16|gold': '12-way-mated-deutsch-dt-key-a-connector-kit-dt04-12pa-and-dt06-12sa-e008-20-16-awg',
          '12|flanged_mated|standard|20-16|gold': '12-way-mated-deutsch-dt-key-a-connector-kit-dt04-12pa-l012-and-dt06-12sa-gold-20-16-awg'
        };
        this.querySelectorAll('[data-step] [data-value]').forEach((button) => button.addEventListener('click', () => this.select(button.closest('[data-step]').dataset.step, button.dataset.value)));
        this.querySelector('[data-reset]').addEventListener('click', () => this.reset());
        this.update();
      }

      needsHousingStyle() {
        return ['mated', 'plug', 'flanged_mated'].includes(this.state.kitType);
      }

      select(step, value) {
        const index = this.order.indexOf(step);
        this.state[step] = value;
        this.order.slice(index + 1).forEach((key) => { this.state[key] = null; });
        if (step === 'kitType' && !this.needsHousingStyle()) this.state.housingStyle = 'standard';
        this.update();
      }

      update() {
        const styleRequired = this.needsHousingStyle();
        this.steps.housingStyle.hidden = Boolean(this.state.kitType) && !styleRequired;
        const enabled = {
          ways: true,
          kitType: Boolean(this.state.ways),
          housingStyle: Boolean(this.state.ways && this.state.kitType && styleRequired),
          wireRange: Boolean(this.state.ways && this.state.kitType && (!styleRequired || this.state.housingStyle)),
          plating: Boolean(this.state.ways && this.state.kitType && (!styleRequired || this.state.housingStyle) && this.state.wireRange)
        };

        this.order.forEach((step) => {
          const fieldset = this.steps[step];
          fieldset.disabled = !enabled[step];
          fieldset.classList.toggle('is-pending', !enabled[step]);
          const choices = fieldset.querySelector('.dt-selector__choices');
          choices.classList.toggle('has-selection', Boolean(this.state[step]));
          fieldset.querySelectorAll('[data-value]').forEach((button) => {
            const selected = this.state[step] === button.dataset.value;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
        });

        const complete = Boolean(this.state.ways && this.state.kitType && (!styleRequired || this.state.housingStyle) && this.state.wireRange && this.state.plating);
        this.review.hidden = !complete;
        if (complete) {
          const labels = {
            mated: 'Mated', receptacle: 'Receptacle', plug: 'Plug', flanged_receptacle: 'Flanged receptacle', flanged_mated: 'Flanged mated',
            standard: 'Standard', e008: 'E008', gold: 'Gold', nickel: 'Nickel'
          };
          const parts = [`${this.state.ways}-way`, labels[this.state.kitType]];
          if (styleRequired) parts.push(labels[this.state.housingStyle]);
          parts.push(`${this.state.wireRange} AWG solid contacts`, labels[this.state.plating]);
          this.summary.textContent = parts.join(' · ');
          const key = [this.state.ways, this.state.kitType, this.state.housingStyle, this.state.wireRange, this.state.plating].join('|');
          const handle = this.products[key];
          if (handle) {
            this.resultHeading.textContent = 'Your DT kit is available';
            this.notice.textContent = 'Open the product page to review pricing, availability, and quantity discounts.';
            this.productLink.href = `/products/${handle}`;
            this.productLink.hidden = false;
            this.status.textContent = `Available DT configuration selected: ${parts.join(', ')}.`;
          } else {
            this.resultHeading.textContent = 'This configuration is not currently available';
            this.notice.textContent = 'We plan to stock this combination, but its product listing has not been prepared yet.';
            this.productLink.removeAttribute('href');
            this.productLink.hidden = true;
            this.status.textContent = `Unavailable DT configuration selected: ${parts.join(', ')}.`;
          }
          this.review.focus({ preventScroll: true });
        }
      }

      reset() {
        this.state = Object.fromEntries(this.order.map((key) => [key, null]));
        this.update();
        this.steps.ways.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.steps.ways.querySelector('[data-value]').focus({ preventScroll: true });
        this.status.textContent = 'DT kit selector reset.';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksv-category-directory"]) return;
  try {
    
  const resetCategoryDirectoryScroll = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections' || !window.location.hash) {
      return;
    }
    if (!document.querySelector('.ksv-category-directory__view:target')) {
      return;
    }
    requestAnimationFrame(() => window.scrollTo(0, 0));
  };

  resetCategoryDirectoryScroll();
  window.addEventListener('load', resetCategoryDirectoryScroll);
  window.addEventListener('hashchange', resetCategoryDirectoryScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
